/* RESPONSIBLE TEAM: team-omni */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';

class FinAIAgentDeployApiRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;

  get titleToken() {
    return this.intl.t('ai-agent.deploy.api');
  }

  reactEnabled() {
    return this.appService.app.canUseFinAgentApi;
  }
}

export default ReactRoute(FinAIAgentDeployApiRoute);
